import { Mapper } from "@bluefalcon/clients-management-client-fetch";
import { Box, Button, Flex, Table, TableCaption, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { mappersService } from "../../services";
import { Link } from "react-router-dom";
import { LoadingSpinner } from "../base/loading-spinner/loading-spinner.comp";
import { mapperEntity } from "../../constants/mapper-entity.constants";

type MappersTableProps = {};

export const MappersTable = ({ }: MappersTableProps) => {

    const [mappers, setMappers] = useState<Mapper[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const fetchMappers = async () => {
        setIsLoading(true);
        const { results, total: _total } = await mappersService.searchMappers({});
        setMappers(results);
        setTotal(_total);
        setIsLoading(false);
    };

    useEffect(() => {
        fetchMappers();
    }, []);

    if (!isLoading && total === 0) {
        return (
            <Box>
                <Box textAlign={'center'} mt={4}>
                    No mappers found.
                </Box>
                <Box textAlign={'center'} mt={4}>
                    <Button to={'/mappers/add'} as={Link} colorScheme="success">
                        Add Mapper
                    </Button>
                </Box>
            </Box>
        )
    }

    if (isLoading) {
        return <LoadingSpinner />
    }

    return (
        <>
            <Flex>
                <Button to={'/mappers/add'} as={Link} ml={'auto'} colorScheme="teal">Add Mapper</Button>
            </Flex>
            <Table variant="simple">
                <TableCaption textAlign={'left'}>Total Mappers: {total}</TableCaption>
                <Thead>
                    <Tr>
                        <Th>ID</Th>
                        <Th>Name</Th>
                        <Th>Description</Th>
                        <Th>Entity Type</Th>
                        <Th>Active</Th>
                        <Th>Actions</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {mappers.map((mapper) => (
                        <Tr key={mapper.id}>
                            <Td>{mapper.id}</Td>
                            <Td>{mapper.name}</Td>
                            <Td>{mapper.description}</Td>
                            <Td>{mapperEntity[mapper.entityType]}</Td>
                            <Td color={mapper.active ? 'success.500' : 'danger.500'}>{mapper.active ? 'Active' : 'Inactive'}</Td>
                            <Td>
                                <Button to={`/mappers/edit/${mapper.id}`} as={Link} mr={2} size="sm">
                                    Edit
                                </Button>
                            </Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>
        </>
    )
};
